<template>
  <!-- Süsteem -> Seaded -> Uued vaated -> Süsteemi lehed uues kujunduses: the
       Süsteem pages in the hooldusplaat look — a head that says what the page
       is for, tabs to the other Süsteem pages, and the page's own cards,
       tables and buttons restyled by styles/system-plate.css. Off, the page
       is exactly what it was: the old heading and the page under it. -->
  <div v-if="plate" class="sys-plate">
    <div class="sys-head">
      <div class="sys-head-text">
        <div class="sys-cap">Süsteem<template v-if="section"> › {{ section }}</template></div>
        <h1 class="sys-title">{{ title }}</h1>
        <p v-if="hint" class="sys-hint">{{ hint }}</p>
      </div>
      <version-tag />
    </div>
    <nav class="sys-tabs" aria-label="Süsteemi lehed">
      <router-link v-for="tab in tabs" :key="tab.name" :to="{ name: tab.name }" class="sys-tab" :class="{ on: isOn(tab) }">{{ tab.text }}</router-link>
    </nav>
    <slot />
  </div>
  <div v-else>
    <!-- Word for word the old heading: "Turvalisus · Kliendid". -->
    <div class="sys-old-head">
      <heading>{{ section ? section + ' · ' + title : title }}</heading>
      <version-tag />
    </div>
    <slot />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VersionTag from '@/components/VersionTag.vue'
import loadArchivo from '@/plugins/archivo'
import '@/styles/system-plate.css'

// The Süsteem pages in the menu's order.
const TABS = [
  { name: 'system/settings', text: 'Seaded' },
  { name: 'system/backup', text: 'Varundus' },
  { name: 'system/reminders', text: 'Meeldetuletused' },
  { name: 'system/sms', text: 'SMS' },
  { name: 'system/mail', text: 'E-post' },
  { name: 'system/stats', text: 'Statistika' },
  { name: 'system/security/clients', text: 'Turvalisus' },
  { name: 'system/security/passkeys', text: 'Pääsuvõtmed', group: 'security' },
  { name: 'system/security/passwords', text: 'Lekkinud paroolid', group: 'security' },
  { name: 'system/data/cities', text: 'Linnad', group: 'data' },
  { name: 'system/data/countries', text: 'Riigid', group: 'data' },
  { name: 'system/data/unpaid', text: 'Maksmata', group: 'data' }
]

export default {
  components: { VersionTag },
  props: {
    title: { type: String, required: true },
    // The new look only: the line under the title, and the group it sits in.
    hint: { type: String, default: '' },
    section: { type: String, default: '' }
  },
  computed: {
    ...mapState(['features']),
    plate () {
      return !!(this.features && this.features.systemPlate)
    },
    tabs: () => TABS
  },
  watch: {
    plate: {
      handler (on) {
        if (on) loadArchivo()
      },
      immediate: true
    }
  },
  methods: {
    isOn (tab) {
      return this.$route.name === tab.name
    }
  }
}
</script>
